import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMySolicitationsUpdateEvent
 *
 * - Evento emitido quando uma solicitação é atualizada no meu espaço.
 */
export class MySpaceMySolicitationsUpdateEvent extends CreateCommand(
  RealtimeEventType.MySpaceMySolicitationsUpdate,
  SCHEMA,
) {}
